'use client';

import BoardContentContext from '@/context/apps/board/BoardContentContext';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import NewsBoardDetail from '@/components/apps/pages/about/news/Detail';
import VisuallyHiddenPageTitle from '@/components/apps/ui/a11y/VisuallyHiddenPageTitle';

import type { BoardContentDetail } from '@/types/boardContent';

export default function NewsDetailPageClient({
  data,
}: {
  data: BoardContentDetail;
}) {
  return (
    <BoardContentContext.Provider value={{ data }}>
      <VisuallyHiddenPageTitle>{data.bc.title}</VisuallyHiddenPageTitle>
      <ResponsiveLayout
        desktopPadding={{ top: '0', bottom: '200px' }}
        mobilePadding={{ top: '40px', bottom: '100px' }}
      >
        <NewsBoardDetail />
      </ResponsiveLayout>
    </BoardContentContext.Provider>
  );
}
